/**
 * Route for `link-management-crud-permission-scope`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LinkManagementCrudPermissionScopePage } from "../features/link-management-crud-permission-scope/LinkManagementCrudPermissionScopePage";

export const linkManagementCrudPermissionScopeRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/link-management-crud-permission-scope",
	component: LinkManagementCrudPermissionScopePage,
});

export default linkManagementCrudPermissionScopeRoute;
